<template>
  <div id="app">
    <router-view/>
    <cookie-law theme="dark-lime" >
      <div slot-scope="props" style="width: 100%">
          Cookies are used for Google Analytics. More info: 
          <router-link to="/privacy"> <span style="color: white"> <u>Here</u> </span> </router-link>
          <a style="position: absolute; right: 20px; cursor:pointer" class="skew" @click.prevent="props.accept"><span style="color: white"> <u> Accept </u></span></a>
      </div>
    </cookie-law>
  </div>
</template>

<script>
  import CookieLaw from 'vue-cookie-law'
  export default {
    components: { CookieLaw }
  }
</script>

<style lang="scss">
</style>
